import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { HelmetProvider } from "react-helmet-async"
import "./index.css"
import App from "./app.tsx"
import { ThemeProvider } from "@/components/theme-provider.tsx"
import { TooltipProvider } from "@/components/ui/tooltip"
import { queryClient } from "@/lib/query-client"
import { Toaster } from "@/components/ui/sonner"
import { initCookieConsent } from "@/lib/cookie-consent"

// Defer PostHog init until the browser is idle so it doesn't block first paint.
// Dynamic import keeps posthog-js out of the main bundle.
const initPostHogDeferred = () => {
  import("@/lib/posthog")
    .then(({ initPostHog }) => initPostHog())
    .catch(() => {
      /* analytics is non-critical */
    })
}

if (typeof window !== "undefined") {
  if ("requestIdleCallback" in window) {
    ;(window as Window).requestIdleCallback(initPostHogDeferred)
  } else {
    setTimeout(initPostHogDeferred, 1)
  }
}

initCookieConsent()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <TooltipProvider>
            <App />
          </TooltipProvider>
        </ThemeProvider>
        <Toaster />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>
)
